import { render } from "./SquareBadge.vue?vue&type=template&id=b54498e0"
import script from "./SquareBadge.vue?vue&type=script&lang=ts"
export * from "./SquareBadge.vue?vue&type=script&lang=ts"
script.render = render

export default script